import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2f0d4af4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container font-weight-light mt-3" }
const _hoisted_2 = { class: "text-center mb-4" }
const _hoisted_3 = { class: "fw-bold mb-2 display-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, " Cover Letter Example", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-muted" }, [
  /*#__PURE__*/_createTextVNode("A "),
  /*#__PURE__*/_createElementVNode("i", null, "Genuine"),
  /*#__PURE__*/_createTextVNode(" Cover Letter Example That Got A Candidate Hired")
], -1))
const _hoisted_6 = { class: "callout bg-primary-subtle d-flex align-items-center m-1 text-black-30" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-square-fill fs-3 me-3" }, null, -1))
const _hoisted_8 = { class: "fw-light" }
const _hoisted_9 = { class: "p-body row w-100" }
const _hoisted_10 = { class: "col-md-6 col-12" }
const _hoisted_11 = ["src", "alt"]
const _hoisted_12 = { class: "col-md-6 col-12 m-auto border-start" }
const _hoisted_13 = { class: "pt-3" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h4 mb-2" }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createElementVNode("i", null, "Why This Cover Letter Works")
  ])
], -1))
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<div class=\"mb-4\" data-v-2f0d4af4><h3 class=\"h4 mb-2\" data-v-2f0d4af4><b data-v-2f0d4af4><i data-v-2f0d4af4>Essential Guidelines for a <u data-v-2f0d4af4>Compelling</u> Cover Letter</i></b></h3><h3 class=\"h5 mb-2 ppt-2\" data-v-2f0d4af4>💪 Begin with a Strong Introduction</h3><p data-v-2f0d4af4> Begin your cover letter with a specific reference to the job title or company. Hiring managers are looking for genuine interest in the role and by demonstrating that you&#39;ve tailored your application, you&#39;ll stand out from applicants using generic templates. </p></div><div class=\"mb-4\" data-v-2f0d4af4><h3 class=\"h5 mb-2\" data-v-2f0d4af4>✅ Highlight Key Skills and Accomplishments</h3><p data-v-2f0d4af4> Mention key skills and notable accomplishments that align with the job requirements, such as streamlining operations or leading a successful project. Detailing these specifics demonstrates your qualifications and the tangible value you bring. </p></div><div class=\"mb-4\" data-v-2f0d4af4><h3 class=\"h5 mb-2\" data-v-2f0d4af4>🤵 Demonstrate Alignment with Company Values</h3><p data-v-2f0d4af4> Illustrate your alignment with the company&#39;s values by mentioning your admiration for their work or ethos, like their dedication to sustainability or innovation. This shows your genuine interest and cultural fit. </p></div><div class=\"mb-4\" data-v-2f0d4af4><h3 class=\"h5 mb-2\" data-v-2f0d4af4>🔎 Utilize Keywords from the Job Posting</h3><p data-v-2f0d4af4> Incorporate keywords from the job description into your cover letter to tailor it to the specific role and demonstrate your attention to detail. This technique ensures your application resonates with hiring managers and aligns with the job requirements. </p></div><div class=\"mb-4\" data-v-2f0d4af4><h3 class=\"h5 mb-2\" data-v-2f0d4af4>📢 End with a Persuasive Call to Action</h3><p data-v-2f0d4af4> Conclude your cover letter with a strong call to action, urging the hiring manager to invite you for an interview. Express your enthusiasm about the possibility of contributing to the company, which can prompt them to move your application forward. </p></div><div class=\"mb-4\" data-v-2f0d4af4><h3 class=\"h5 mb-2\" data-v-2f0d4af4>💼 Employ a Professional Format</h3><p data-v-2f0d4af4> Use a clean, professional template for your cover letter to create a positive visual impression. Ensure it is neatly organized and easy to read, which reflects your professionalism. </p></div>", 6)
const _hoisted_21 = { class: "m-1 rounded bg-body-tertiary" }
const _hoisted_22 = { class: "m-3 text-body p-3" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2 text-body" }, [
  /*#__PURE__*/_createElementVNode("b", null, [
    /*#__PURE__*/_createTextVNode("Create Your Cover Letter in "),
    /*#__PURE__*/_createElementVNode("u", null, [
      /*#__PURE__*/_createElementVNode("i", null, "Seconds")
    ]),
    /*#__PURE__*/_createTextVNode(" and "),
    /*#__PURE__*/_createElementVNode("u", null, [
      /*#__PURE__*/_createElementVNode("i", null, "for Free")
    ]),
    /*#__PURE__*/_createTextVNode(" with Job"),
    /*#__PURE__*/_createElementVNode("span", { class: "text-primary" }, "Buddy")
  ]),
  /*#__PURE__*/_createTextVNode(" 💡 ")
], -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Each of these cover letters was carefully researched, written and formatted using the most advanced AI cover letter generator in the world. Sign up for free to create your own cover letters. It's easy, fast and free. ", -1))
const _hoisted_25 = { class: "row mt-5 w-100 m-1" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-primary btn-lg w-100" }, "Create Cover Letter", -1))
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "row m-1 text-body p-3 bg-body-tertiary rounded" }
const _hoisted_29 = { class: "col-12 col-sm-6 order-1 order-sm-1" }
const _hoisted_30 = { class: "h5 mb-2 mt-5 text-body" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "real-world", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Optimized for Applicant Tracking Systems", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Professionally Crafted Design", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "Demonstrated Effectiveness", -1))
const _hoisted_39 = { class: "col-12 col-sm-6 order-2 order-sm-2 d-flex justify-content-center align-items-center" }
const _hoisted_40 = ["src"]
const _hoisted_41 = { class: "col-12 col-sm-6 order-3 order-sm-3 d-flex justify-content-center align-items-center" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-primary btn-lg w-100" }, "View This Resume", -1))
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2 mt-5" }, [
  /*#__PURE__*/_createElementVNode("b", null, "More Cover Letter Examples")
], -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Browse more cover letter examples for different roles and industries. Each cover letter example is based on a real cover letter that got a candidate hired. ", -1))
const _hoisted_45 = { class: "row" }
const _hoisted_46 = { class: "d-flex" }
const _hoisted_47 = { class: "overflow-x-auto w-100 d-flex scroll-container" }
const _hoisted_48 = {
  class: "card border-0 m-2",
  style: {"width":"18rem"}
}
const _hoisted_49 = ["src", "alt"]
const _hoisted_50 = { class: "card-body" }
const _hoisted_51 = { class: "card-title text-secondary" }
const _hoisted_52 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "h5 mb-2 mt-5" }, [
  /*#__PURE__*/_createElementVNode("b", null, "See All Cover Letter Examples")
], -1))
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Browse our full cover letter example collection, with a variety of cover letters for different roles and industries. ", -1))
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "btn btn-outline-primary btn-lg w-100" }, "View All Cover Letters", -1))

import { useHead } from "@unhead/vue";
import { onMounted, ref, watch } from "vue";
import { useRoute } from "vue-router";
import { CoverLetterExample, coverLetterExamples } from "./blogs/CoverLetterExamples";


export default /*#__PURE__*/_defineComponent({
  __name: 'CoverLetterDetail',
  setup(__props) {

const route = useRoute();
const coverLetterExample = ref<CoverLetterExample | undefined>();
// Fetch initial cover letter example based on the initial route.
onMounted(() => {
  loadCoverLetterExample();
});

// Watch for route changes to update the cover letter example.
watch(
  () => route.params.role,
  (newRole) => {
    loadCoverLetterExample();
  }
);

watch(
  () => coverLetterExample.value,
  (newVal) => {
    if (newVal) {
      useHead({
        title: `Cover Letter for a ${newVal.Role} Position`,
        meta: [
          {
            name: "description",
            content: `Discover how this standout cover letter for a ${newVal.Role.toLowerCase()} position helped a candidate secure a job. Learn key tips and strategies to enhance your own cover letter.`,
          },
          {
            name: "keywords",
            content: `${
              newVal.Role
            } cover letter, successful ${newVal.Role.toLowerCase()} cover letter example, JobBuddy cover letter tips, cover letter strategies, professional cover letter templates`,
          },
        ],
      });
    }
  },
  { immediate: true }
);

function loadCoverLetterExample() {
  const role = route.params.role?.toLowerCase();
  coverLetterExample.value = coverLetterExamples.find(
    (example) => example.key.toLowerCase() === role
  );
}

function getImageUrl(path: any): string {
  if (!path) {
    console.error("Invalid path provided");
    return ""; // Return a default image path or an error image
  }
  return require(`../../public/media/coverLetterExamples/${path}`);
}

function getImageUrlForResume(path: any): string {
  if (!path) {
    console.error("Invalid path provided");
    return ""; // Return a default image path or an error image
  }
  return require(`../../public/media/resumeExamples/${path}`);
}

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, [
        _createTextVNode(_toDisplayString(coverLetterExample.value?.Role), 1),
        _hoisted_4
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _createElementVNode("p", _hoisted_8, " This cover letter example helped a real JobBuddy user secure their " + _toDisplayString(coverLetterExample.value?.Role.toLowerCase()) + " position. Shared with permission to assist you in your job search, names and places have been changed to protect their privacy. ", 1)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("img", {
          src: getImageUrl(coverLetterExample.value?.ExampleImgSrc),
          alt: `Cover letter example for ${coverLetterExample.value?.Role}`,
          class: "img-fluid d-block my-3 w-100 shadow",
          loading: "lazy"
        }, null, 8, _hoisted_11)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _hoisted_14,
          _createElementVNode("p", null, _toDisplayString(coverLetterExample.value?.WhyItWorked) + ".", 1)
        ]),
        _hoisted_15
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _hoisted_24,
        _createElementVNode("div", _hoisted_25, [
          _createVNode(_component_router_link, { to: { name: 'Dashboard' } }, {
            default: _withCtx(() => [
              _hoisted_26
            ]),
            _: 1
          })
        ])
      ])
    ]),
    (getImageUrlForResume(coverLetterExample.value?.ExampleImgSrc))
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("h3", _hoisted_30, [
                _createElementVNode("b", null, _toDisplayString(coverLetterExample.value?.Role) + " Resume That Got A Candidate Hired", 1)
              ]),
              _createElementVNode("span", null, [
                _createTextVNode(" Explore a "),
                _hoisted_31,
                _createTextVNode(" " + _toDisplayString(coverLetterExample.value?.Role.toLocaleLowerCase()) + " resume that successfully secured a job offer. ", 1)
              ]),
              _hoisted_32,
              _hoisted_33,
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _hoisted_38
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("img", {
                class: "m-auto",
                style: {"max-height":"350px","max-width":"100%"},
                src: getImageUrlForResume(coverLetterExample.value.ExampleImgSrc),
                loading: "lazy"
              }, null, 8, _hoisted_40)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _createVNode(_component_router_link, {
                to: { name: 'ResumeDetail', params: _unref(route).params.role }
              }, {
                default: _withCtx(() => [
                  _hoisted_42
                ]),
                _: 1
              }, 8, ["to"])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _hoisted_43,
      _hoisted_44,
      _createElementVNode("div", _hoisted_45, [
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(coverLetterExamples), (example) => {
              return (_openBlock(), _createBlock(_component_router_link, {
                key: example.Role,
                to: {
                name: 'CoverLetterDetail',
                params: { role: example.Role.toLowerCase().replace(/ /g, '-') },
              },
                style: {"text-decoration":"none"},
                class: "col"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_48, [
                    _createElementVNode("img", {
                      src: getImageUrl(example.ExampleImgSrc),
                      alt: `Cover letter example for ${example.Role}`,
                      class: "shadow m-1 example-card",
                      loading: "lazy"
                    }, null, 8, _hoisted_49),
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("h5", _hoisted_51, _toDisplayString(example.Role), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1032, ["to"]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", null, [
        _hoisted_52,
        _hoisted_53,
        _createElementVNode("div", null, [
          _createVNode(_component_router_link, { to: { name: 'CoverLetterExamples' } }, {
            default: _withCtx(() => [
              _hoisted_54
            ]),
            _: 1
          })
        ])
      ])
    ])
  ]))
}
}

})